import { render, staticRenderFns } from "./server-tj.vue?vue&type=template&id=279af778&scoped=true"
import script from "./server-tj.vue?vue&type=script&lang=js"
export * from "./server-tj.vue?vue&type=script&lang=js"
import style0 from "./server-tj.vue?vue&type=style&index=0&id=279af778&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279af778",
  null
  
)

export default component.exports